export enum ViewportSize {
    PHONE_S = 320,
    PHONE_M = 480,
    PHONE_L = 480,
    TABLET = 768,
    DESKTOP_S = 1024,
    DESKTOP_M = 1366,
    DESKTOP_M_MAX = 1600,
    DESKTOP_L = 1920,
}
